module.exports = __webpack_public_path__ + "img/Calendar3.da9ad351.svg";